import { TranslationSource as TranslationSourceEnum } from "@redotech/crdb-enums/returns/translation-source";

export const TRANSLATION_SOURCES: readonly TranslationSource[] = Object.values(
  TranslationSourceEnum,
);

export type TranslationSource = `${TranslationSourceEnum}`;
